export default {"src":"/_next/static/media/chevron-dark.cd08020c.svg","height":16,"width":16};